import TopNav from "@/components/dashboard/general/navigation/TopNav";

import { ReactNode } from "react";

export default function BaseLayout({ children }: { children: ReactNode }) {
    return (
        <div className="flex h-full flex-col">
            {/* Top Navigation */}
            <div className="fixed top-0 z-50 w-full">
                <TopNav />
            </div>

            {/* Main Content */}
            <main className="flex-1 overflow-auto pt-16">
                <div className="">{children}</div>
            </main>
        </div>
    );
}
